export const setPetData = (petData) => {
    return {
        type: 'SET_PET_DATA',
        payload: petData.map((item) => ({
            ...item,
            birth: item.birth.toDate().toLocaleDateString(),
            created: item.created.toDate().toISOString(),
            updated: item.updated.toDate().toISOString(),
        })),
    };
}

export const clearPetData = () => {
    return {
        type: 'CLEAR_PET_DATA',
    };
}